import styled from 'styled-components';

export const OfficeViewerContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100vh;
	overflow: hidden;
`;

export const OfficeViewerForm = styled.div`
	display: none;
`;

export const OfficeViewerFormFrameHolder = styled.div`
	width: 100%;
	height: 100%;
`;

export const StyledDiv = styled.div`
	position: relative;
	width: 100dvw;
	height: 85dvh;
	overflow: hidden;
`;

export const StyledForm = styled.form`
	display: none;
`;

export const StyledButton = styled.button`
	position: absolute;
	top: 10px;
	right: 10px;
	background-color: red;
	color: #fff;
	border: none;
	border-radius: 50%;
	width: 30px;
	height: 30px;
	font-size: 16px;
	font-weight: bold;
	cursor: pointer;
`;

export const StyledModalContainer = styled.div`
	position: fixed;
	z-index: 100;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const StyledModalContent = styled.div`
	background-color: #fff;
	position: relative;
	width: 100%;
	height: 100%;
	overflow: auto;
	position: fixed;
`;

export const StyledFrameHolder = styled.div`
	width: 100%;
	height: 100%;
`;
